import React from "react";
import { useParams } from "react-router-dom";
import List from "../../components/List/List";

const EssencesList = () => {
    const { essenceSlug } = useParams();

    // Just pass the essenceSlug as a prop to List
    return (
        <div className="essence-product-list">
            <h1 style={{ textTransform: 'capitalize', margin: "30px" }}>{essenceSlug} Essences</h1>
            <List essenceSlug={essenceSlug} />
        </div>
    );
};

export default EssencesList